<template>
  <div>
    <!-- mobile / tablet -->
    <div v-if="$mq != 'desktop'" class="viz-container">
      <b-container>
        <b-row>
          <b-col>
            <div class="title">
              <span v-text="content.title"/>
            </div>
            <div class="description">
              <span v-text="content.description"/>
            </div>
            <div v-if="content.mobile_legend" class="mobile_legend">
              <img :src="'./images/'+content.mobile_legend" alt="">
            </div>
            <div class="container-img">
              <img v-for="(img,i) in content.mobile" :key="i" class="img" :src="'./images/'+img"/>
            </div>
            <div class="source">
              <span v-text="content.source"/>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- desktop -->
    <div v-else class="viz-container-desktop">
      <!-- viz type 1 -->
      <div v-if="content.type_desktop == 1" class="type-1">
        <b-container>
          <NoteViz :content="content"/>
          <b-row>
            <b-col :cols="content.desktop_cols">
              <img v-for="(img,i) in content.desktop" :key="i" class="img" :src="'./images/'+img"/>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <!-- viz type 2 -->
      <div v-else class="type-2">
        <b-container>
          <b-row class="row-info">
            <div class="title" v-html="content.title"></div>
            <div class="description" v-html="content.description"></div>
          </b-row>
          <b-row>
            <b-col cols="10">
              <img class="img" :src="'./images/'+content.desktop"/>
            </b-col>
          </b-row>
          <b-row class="row-info">
            <div class="source">
              <span v-text="content.source"/>
            </div>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script>
import NoteViz from '../components/NoteViz.vue'
export default {
  name: 'Viz',
  props: ["content"],
  components: {
    NoteViz
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<!-- Use preprocessors via the lang attribute! e.g. <style lang="scss"> -->
<style lang="scss" scoped>
@import "@/assets/scss/bper-fonts.scss";
@import "@/assets/scss/colors.scss";
.viz-container{
  position: relative;
  background-color: $bper-verde-scuro;
  margin-bottom: 40px;
  padding-top: 32px;
  .title{
    font-family: KievitOT;
    max-width: 300px;
    font-weight: 500;
    font-size: 14px;
    color: $bper-bianco;
    margin-bottom: 18px;
    span{
      border: 1px solid $bper-bianco;
      border-radius: 3px;
      padding: 4px;
    }
  }
  .description{
    font-family: KievitOT;
    max-width: 260px;
    font-size: 14px;
    line-height: 30px;
    color: $bper-verde-scuro;
    margin-bottom: 32px;
    span{
      background-color: $bper-bianco;
      border-radius: 3px;
      padding: 4px;
    }
  }
  .mobile_legend{
    position: relative;
    justify-content: center;
    padding-bottom: 32px;
    padding-left: 21px;
    padding-right: 21px;
    img{
      position: relative;
      max-width: 300px;
      height: auto;
    }
  }
  .container-img{
    display: flex;
    flex-direction: column;
    align-items: center;
    .img{
      max-width: 340px;
      margin-bottom: 24px;
    }
  }
  .source{
    font-family: KievitOT;
    max-width: 260px;
    font-size: 12px;
    line-height: 16px;
    color: $bper-bianco;
    margin-bottom: 32px;
    span{
      padding: 4px;
      border: 1px solid $bper-bianco;
      border-radius: 3px;
    }
  }
}
.viz-container-desktop{
  padding-bottom: 64px;
  .type-1{
    .container{
      .row{
        display: flex;
        flex-direction: column;
        align-items: center;
        .img{
          width: 100%;
          margin-top: 160px;
        }
      }
    }
  }
  .type-2{
    position: relative;
    width: 100%;
    background-color: $bper-verde-scuro;
    .container{
      .row{
        display: flex;
        flex-direction: column;
        align-items: center;
        .img{
          width: 100%;
        }
      }
      .row-info{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-top: 40px;
        .title{
          font-family: KievitOT;
          font-weight: 500;
          font-size: 18px;
          color: $bper-bianco;
          border: 1px solid $bper-bianco;
          border-radius: 3px;
          padding: 4px;
          margin-bottom: 8px;
        }
        .description{
          font-family: KievitOT;
          font-size: 16px;
          line-height: 18px;
          color: $bper-verde-scuro;
          background-color: $bper-bianco;
          border-radius: 3px;
          padding: 4px;
          margin-bottom: 32px;
        }
        .source{
          font-family: KievitOT;
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 32px;
          span{
            border: 1px solid $bper-bianco;
            color: $bper-bianco;
            border-radius: 3px;
            padding: 4px;
          }
        }
      }
    }
  }
}
// -- media query tablet
@media only screen 
  and (min-device-width: 450px) 
  and (max-device-width: 1250px) {
    .viz-container{
      .mobile_legend{
        img{
          width: 50%;
        }
      }
    }
}
</style>